import { render, staticRenderFns } from "./EventsCard.vue?vue&type=template&id=7ad69e7d&scoped=true"
import script from "./EventsCard.vue?vue&type=script&lang=js"
export * from "./EventsCard.vue?vue&type=script&lang=js"
import style0 from "./EventsCard.vue?vue&type=style&index=0&id=7ad69e7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad69e7d",
  null
  
)

export default component.exports